// extracted by mini-css-extract-plugin
export var bodyRow = "_et-d";
export var cardColumns = "_et-e";
export var ellipsesOverflow = "_et-2";
export var flatBottomCorners = "_et-3";
export var flatTopCorners = "_et-4";
export var headerActionsDropdown = "_et-f";
export var headerBottomRow = "_et-c";
export var headerTopRow = "_et-b";
export var orderDetailsWrapper = "_et-0";
export var orderInfoContainer = "_et-1";
export var productDetails = "_et-9";
export var productImage = "_et-5";
export var responsiveTable = "_et-8";
export var shipmentContainer = "_et-a";
export var tableBottomLeft = "_et-6";
export var tableBottomRight = "_et-7";
export var trackingLink = "_et-g";